import { Divider, Drawer, Input, Space, Slider, Tooltip } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import RichTextEditor from "../../UI/RichTextEditor";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import Html from "../../../utils/Html";
import { tt_hp_gap, tt_name_block_warning, tt_padding_x, tt_padding_y } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";

export default function HeadlineParagraph(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 100,
        gap = 0,
        align = "left",
        text_align = "left",
        padding_x = 10,
        padding_y = 10,
        heading = "Heading...",
        heading_preset = 0,
        paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
        paragraph_preset = 0,
        background_colour = 0,
        link_id = 0,
    } = data;

    const save = () => {
        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            maxWidth: (1248 * (width / 100)) + "px",
            alignSelf: "flex-end",
            textAlign: text_align,
        }

        let _align = {
            display: "flex",
            flexDirection: "column",
            background: getColor(background_colour, template)
        }

        switch (align) {
            case "center":
                _style.alignSelf = "center";
                break;
            case "right":
                _style.alignSelf = "flex-end";
                break;
            default:
                _style.alignSelf = "flex-start";
                break;
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_align}>
                    <div style={_style}>
                        {(heading &&
                            <h2 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                                {heading}
                            </h2>
                        )}
                        {((gap > 0) &&
                            <div className="shim" style={{ "height": gap + "px" }} />
                        )}
                        {(paragraph &&
                            <div className={"bm-txt-" + paragraph_preset} >
                                <Html anchor={"bm-lnkin-"+link_id} html={paragraph} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const formatter = (value) => `${value}%`;

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "150px" }}
                        min={0}
                        max={100}
                        tooltip={{
                            formatter,
                          }}
                        formatter={(_v) => `${_v}%`}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                    <Space>
                        <div><Tooltip placement="left" title={<small>Left align the container.</small>}><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip placement="left" title={<small>Center align the container.</small>}><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip placement="left"title={<small>Right align the container.</small>}><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
         
                    <Space>
                        <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={35} value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_hp_gap}>GAP</Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADING PRESET</Divider>
                <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADING</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />

                <div className="group-wrap">
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                <RichTextEditor container={container} link_id={link_id} background_colour={background_colour} padding_x={padding_x} padding_y={padding_y} paragraph_preset={paragraph_preset} text_align={text_align} width={(1248 * (width / 100))} value={paragraph} onChange={(_v) => setData({ ...data, "paragraph": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                
                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}